import { Box, Grid, IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import AdminSidebar from "./Sidebar";
import { useEffect, useState } from "react";
import axios from 'axios'
import { Delete } from "@mui/icons-material";
export default function ContactRequests() {

    var url = `http://localhost:${process.env?.PORT || 3000}/`
    const [requests, setrequests] = useState([]);
    function fetchRequests() {
        axios.post(url + 'getContactRequests').then((succ) => {
            if (succ.data.response == 'failed') {
                alert(succ.data.reason)
            } else {
                setrequests(succ.data.results);
                console.log('Results', succ.data.results)
            }
        })
    }

    useEffect(() => {
        fetchRequests();
    }, [])


    return (
        <>

            <Grid container>
                <AdminSidebar />
                <Grid container justifyContent={'center'} size={{ lg: 10 }} px={3} alignItems={'center'} height={'100vh'}>
                    {/* <table className="table stripped">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Contact</th>
                                <th>Reason</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {requests.map((row) => (
                                <tr>
                                    <th>{row.Name}</th>
                                    <th>{row.Email}</th>
                                    <th>{row.Mobile}</th>
                                    <th>{row.Reason}</th>
                                    <th>
                                        <button className="btn-admin-navy">View</button>
                                    </th>
                                    <th>
                                        <button className="btn-outline-admin-navy">Resolved</button>
                                    </th>
                                </tr>
                            ))}
                        </tbody>
                    </table> */}
                    <TableContainer sx={{ background: '#0F1536', color: 'white', borderRadius: 2 }}>
                        <Table aria-label="caption table">
                            {/* <caption>A basic table example with a caption</caption> */}
                            <TableHead>
                                <TableRow>
                                    <TableCell className="text-white">Name</TableCell>
                                    <TableCell className="text-white">Email</TableCell>
                                    <TableCell className="text-white">Contact</TableCell>
                                    <TableCell className="text-white">Reason</TableCell>
                                    <TableCell className="text-white">Description</TableCell>
                                    <TableCell className="text-white">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {requests.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell className="text-white" component="th" scope="row">
                                            {row.Name}
                                        </TableCell>
                                        <TableCell className="text-white">{row.Email}</TableCell>
                                        <TableCell className="text-white">{row.Mobile}</TableCell>
                                        <TableCell className="text-white">{row.Reason}</TableCell>
                                        <TableCell className="text-white"><button className=" btn-outline-white">View</button></TableCell>
                                        
                                        <TableCell className="text-white">
                                            <IconButton color="inherit">
                                                <Delete />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

        </>
    )


}